module.exports = __webpack_public_path__ + "svg/mygreen-white.svg?a942c7ef86ff6146d1b210f1c0a04b9c";